import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import GridWrapper from '@/components/ui/GridWrapper';
import logo from 'icons/schools-logo.svg';

export const Wrapper = styled.section`
	background: ${palette('schoolBlue')};
	display: flex;
	flex-direction: column-reverse;
	overflow: hidden;
	position: relative;
	z-index: 0;

	${minWidth('tablet')} {
		display: block;
		padding: 32px 0 52px;
	}

	${minWidth('desktop')} {
		padding: 52px 0 100px;
	}

	${minWidth('desktopLarge')} {
		padding: 98px 0 120px;
	}
`;

export const Grid = styled(GridWrapper)`
	position: relative;
`;

export const Content = styled.div`
	color: ${palette('white')};
	padding: 240px 0 40px;

	${minWidth('tablet')} {
		padding: 0;
		width: 50%;
	}
`;

export const Logo = styled(logo)`
	margin-bottom: 24px;
	height: 52px;
	width: auto;

	${minWidth('tablet')} {
		height: 64px;
	}

	${minWidth('desktop')} {
		height: 84px;
		margin-bottom: 32px;
	}
`;

export const Heading = styled.h1`
	${fontWeight(FontWeights.Medium)};
	margin-bottom: 12px;
`;

export const BodyText = styled.h4`
	${fontWeight(FontWeights.Medium)};
`;

export const Background = styled(FullscreenBackground)`
	height: 42%;
	width: 100%;

	${minWidth('mobileLarge')} {
		height: 45%;
	}

	${minWidth('tablet')} {
		height: 100%;
		left: 50%;
		width: 50%;
	}

	& img {
		object-position: bottom;

		${minWidth('mobileLarge')} {
			object-position: center;
		}
	}
`;
